import Vue from 'vue';
import Router from 'vue-router';

import ReleaseCreation from './views/ReleaseCreation.vue';
import SpeciesPortal from './views/SpeciesPortal.vue';
import GenesPortal from './views/GenesPortal.vue';
import GeneExploreView from './views/GeneExploreView.vue';
import NotFound from './views/NotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/release_creation',
      name: 'release_creation',
      component: ReleaseCreation,
    },
    {
      path: '/',
      name: 'species',
      component: SpeciesPortal,
    },
    {
      path: '/:species/',
      name: 'genes',
      component: GenesPortal,
      props: true,
    },
    {
      path: '/:species/:release',
      name: 'releaseLocus',
      component: GenesPortal,
      props: true,
    },
    {
      path: '/:species/:release/:geneId',
      name: 'explorerelease',
      component: GeneExploreView,
      props: true,
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound,
    },
  ],
});
